module.exports = __webpack_public_path__ + "static/Wegmans_pin-00d9e47887c310a3337d7ded205f4d75.png";